<template>
<div class="EditableRuleActionList">
   <div class="container-fluid padding-right-0Px padding-left-0px">
      <div class="row vertical-align margin-bottom-2Perc">
            <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-right-0Perc text-align-right">
            </div>
            <div class="col-md-5 col-lg-5 Padding-left-0px font-size-18px">
              <div class="col-lg-12 col-md-12 text-align-left">
                <span>{{(getCurrEditableRuleActionIndex + 1)}}</span>.&nbsp;<span v-html="getNameFromRuleIdAndActionId()"></span>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="col-sm-4"></div>
                <div class="col-sm-2">
                  <img :src="useredit" alt="useredit" height="15" width="15" class="cursor-pointer padding-bottom-3px" @click="performOperation($event,'edit')">
                </div>
                <div class="col-sm-2">
                  <img :src="deleteIcon" alt="useredit" height="15" width="15" class="cursor-pointer padding-bottom-3px" @click="performOperation($event,'delete')">
                </div>
                <div class="col-sm-4"></div>
              </div>
            </div>
            <div class="col-md-1 col-lg-1"></div>  
          </div>
          

    </div>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixConfirmationString" v-bind:postfixString="postConfirmationString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performActionBasedOnInput"></confirmation-alert>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 
</template>

<script>
import { ruleActionService } from '@/server-util/rule-action-service'
import AlertBox from '@/components/AlertOverlay'
import find from 'lodash/find'
import { constants } from '../../utils/constants'
import deleteIcon from '../../assets/images/delete.svg'
import edit from '../../assets/images/edit.svg'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['lessonObj', 'ElementObj', 'elementRuleList', 'actionList', 'editableRuleActionList', 'currEditableRuleActionObj', 'currEditableRuleActionIndex'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      showConfirmationBox: false,
      prefixConfirmationString: '',
      postConfirmationString: '',
      deleteIcon: deleteIcon,
      useredit: edit,
      constants: constants,
      showAlertDialog: false,
      errorMsg: ''
    }
  },
  name: 'EditableRuleActionList',
  methods: {
    performActionBasedOnInput (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteExistingRuleAction()
      }
    },
    performOperation: function (event, operationName) {
      switch (operationName) {
        case 'delete':
          this.showConfirmationBox = true
          this.prefixConfirmationString = 'Are you sure you want to delete '
          this.postConfirmationString = '\'<u>' + this.getRuleName() + '</u>\' rule and it\'s associated \'<u>' + this.getActionName() + '</u>\' action?'
          break
        case 'edit':
          const actionObjFromList = find(this.actionList, (obj) => {
            return obj.ActionMasterId === this.currEditableRuleActionObj.ActionId
          })
          console.log('79: actionObjFromList: ' + JSON.stringify(actionObjFromList))
          if (actionObjFromList !== undefined && actionObjFromList !== 'undefined' && actionObjFromList !== null && actionObjFromList !== 'null' && actionObjFromList !== '') {
            this.currEditableRuleActionObj.ActionType = actionObjFromList.ActionName
          }
          var objToReturn = {
            editableObj: this.currEditableRuleActionObj,
            actionObjFromList: actionObjFromList
          }
          this.$emit('selectedRuleActionObj', objToReturn)
          break
      }
    },
    deleteExistingRuleAction: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== '' &&
        storeObj.state.access_token !== null
      ) {
        this.$store.state.isLoading = true
        ruleActionService.deleteExistingRulesAction(storeObj.state.access_token, _this.currEditableRuleActionObj.ElementRuleActionId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              var objToReturn = {
                OperationName: 'Delete',
                ElementRuleActionId: _this.currEditableRuleActionObj.ElementRuleActionId
              }
              _this.$emit('updatedExistingRuleActionList', objToReturn)
              _this.$store.state.isLoading = false
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            _this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined DELETE EXISTING RULE AND IT\'S ASSOCIATED ACTION OPERATION'
        )
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of Confirmation Box overlay
      this.showConfirmationBox = value
    },
    getNameFromRuleIdAndActionId: function () {
      var nameToShow = ''
      if (this.getCurrEditableRuleActionObj !== undefined && this.getCurrEditableRuleActionObj !== 'undefined' && this.getCurrEditableRuleActionObj !== null && this.getCurrEditableRuleActionObj !== 'null' && this.getCurrEditableRuleActionObj !== '') {
        var obj = find(this.getElementRuleList, (obj) => {
          return obj.RuleMasterId === this.getCurrEditableRuleActionObj.RuleId
        })
        if (obj !== undefined && obj !== 'undefined' && obj !== null && obj !== 'null' && obj !== '') {
          nameToShow = obj.RuleName
        }
        obj = find(this.getActionList, (obj) => {
          return obj.ActionMasterId === this.getCurrEditableRuleActionObj.ActionId
        })
        if (obj !== undefined && obj !== 'undefined' && obj !== null && obj !== 'null' && obj !== '') {
          nameToShow += ' <u>[' + obj.ActionName + ']</u>'
        }
      }
      return nameToShow
    },
    getActionName: function () {
      var nameToShow = ''
      if (this.getCurrEditableRuleActionObj !== undefined && this.getCurrEditableRuleActionObj !== 'undefined' && this.getCurrEditableRuleActionObj !== null && this.getCurrEditableRuleActionObj !== 'null' && this.getCurrEditableRuleActionObj !== '') {
        var obj = find(this.getActionList, (obj) => {
          return obj.ActionMasterId === this.getCurrEditableRuleActionObj.ActionId
        })
        if (obj !== undefined && obj !== 'undefined' && obj !== null && obj !== 'null' && obj !== '') {
          nameToShow += obj.ActionName
        }
      }
      return nameToShow
    },
    getRuleName: function () {
      var nameToShow = ''
      if (this.getCurrEditableRuleActionObj !== undefined && this.getCurrEditableRuleActionObj !== 'undefined' && this.getCurrEditableRuleActionObj !== null && this.getCurrEditableRuleActionObj !== 'null' && this.getCurrEditableRuleActionObj !== '') {
        var obj = find(this.getElementRuleList, (obj) => {
          return obj.RuleMasterId === this.getCurrEditableRuleActionObj.RuleId
        })
        if (obj !== undefined && obj !== 'undefined' && obj !== null && obj !== 'null' && obj !== '') {
          nameToShow = obj.RuleName
        }
      }
      return nameToShow
    },
    setDefaultValues: function () {},
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay
  },
  computed: {
    getEditableRuleActionList: {
      get: function () {
        return this.editableRuleActionList
      }
    },
    getCurrEditableRuleActionObj: {
      get: function () {
        return this.currEditableRuleActionObj
      }
    },
    getElementRuleList: {
      get: function () {
        return this.elementRuleList
      }
    },
    getActionList: {
      get: function () {
        return this.actionList
      }
    },
    getCurrEditableRuleActionIndex: {
      get: function () {
        return this.currEditableRuleActionIndex
      }
    }
  }
}
</script>

<style scoped>
.font-weight-bold-withOpacity75 {
  font-weight: bold;
  opacity: .75;
}
.cursor-default {
  cursor: default !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.border-1px-solid-grey {
  border: 1px solid #aaa;
}
.border-top-1px-solid-grey {
  border-top: 1px solid #dadada;
}
.border-bottom-1px-solid-grey {
  border-bottom: 1px solid #dadada;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red{
  border: 1px solid red; 
}
.padding-left-30px{
  padding-left:30px;
}
.font-size-12px{
  font-size:12px;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-valign-middle{
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/personalization_rule/EditableRuleActionList.vue